if (typeof addLoadEvent === 'undefined'){
    addLoadEvent = function (func) {
        var oldonload = window.onload;
        if (typeof window.onload != 'function') {
            window.onload = func;
        } else {
            window.onload = function() {
                if (oldonload) {
                    oldonload();
                }
                func();
            }
        }
    }
}
addLoadEvent(function(){
    const vendor = accessCookie('seaway_last_partfinder_vendor');
    const partfinder_url = accessCookie('seaway_last_partfinder_url');
    const smartContinueLink = document.querySelector('.smart-continue');
    if (
        smartContinueLink && 
        partfinder_url &&
        (window.location.href != partfinder_url)
    ){
        smartContinueLink.addEventListener('click', function(e){
            e.preventDefault();
            window.location = partfinder_url;
        });
        smartContinueLink.setAttribute('href', partfinder_url);
    }
    function accessCookie(cookieName)
    {
        let name = cookieName + "=";
        let cookieString = document.cookie;
        let allCookieArray = cookieString.split(';');
        for (let i=0; i<allCookieArray.length; i++)
        {
            let temp = allCookieArray[i].trim();
            if (temp.indexOf(name)==0)
            return temp.substring(name.length,temp.length);
            }
        return "";
    }
});